import type { Prenda } from '../hooks/useClienteArmario';

export interface LookSugerido {
  id: string;
  nombre: string;
  ocasion: string;
  prendas: Prenda[];
  temporada: string;
}

const TEMPORADA_MAP: Record<number, string> = {
  0: 'invierno',
  1: 'invierno',
  2: 'primavera',
  3: 'primavera',
  4: 'primavera',
  5: 'verano',
  6: 'verano',
  7: 'verano',
  8: 'otoño',
  9: 'otoño',
  10: 'otoño',
  11: 'invierno',
};

function getTemporadaActual(): string {
  return TEMPORADA_MAP[new Date().getMonth()] ?? 'entretiempo';
}

export function generarLooksSugeridos(
  prendas: Prenda[],
  paleta: string[],
  ocasiones: string[]
): LookSugerido[] {
  const activas = prendas.filter((p) => p.activa);
  if (activas.length === 0 || paleta.length < 2) return [];

  const paletaLower = paleta.map((c) => c.toLowerCase());
  const prendasPaleta = activas.filter((p) =>
    paletaLower.some((col) => p.color.toLowerCase().includes(col))
  );
  if (prendasPaleta.length < 2) return [];

  const tops = prendasPaleta.filter((p) =>
    ['camiseta', 'camisa', 'blusa', 'suéter', 'sweater', 'jersey', 'blazer', 'top'].some((t) =>
      p.categoria.toLowerCase().includes(t)
    )
  );
  const bottoms = prendasPaleta.filter((p) =>
    ['pantalón', 'pantalon', 'falda', 'vestido', 'short', 'jeans', 'bermuda'].some((t) =>
      p.categoria.toLowerCase().includes(t)
    )
  );
  const outerwear = prendasPaleta.filter((p) =>
    ['chaqueta', 'abrigo', 'cardigan', 'cazadora', 'trenca', 'parka', 'americana'].some((t) =>
      p.categoria.toLowerCase().includes(t)
    )
  );
  const accesorios = prendasPaleta.filter((p) =>
    ['bolso', 'cinturón', 'cinturon', 'bufanda', 'pañuelo', 'gorro', 'sombrero', 'zapatos', 'botas', 'cartera'].some((t) =>
      p.categoria.toLowerCase().includes(t)
    )
  );

  const looks: LookSugerido[] = [];
  const usedCombos = new Set<string>();
  const temporada = getTemporadaActual();

  const nombresBase = [
    'Look Elegante',
    'Look Casual',
    'Look Atemporal',
    'Look Versátil',
    'Look Confianza',
    'Look Chic',
    'Look Urbano',
    'Look Sofisticado',
  ];

  const maxLooks = Math.min(6, Math.floor(prendasPaleta.length / 2));

  for (let i = 0; i < maxLooks; i++) {
    const top = tops[i % tops.length] ?? tops[0];
    const bottom = bottoms[i % bottoms.length] ?? bottoms[0];
    const layer = outerwear.length > 0 ? outerwear[i % outerwear.length] : null;
    const acc = accesorios.length > 0 ? accesorios[i % accesorios.length] : null;

    const prendaIds = [top?.id, bottom?.id, layer?.id, acc?.id].filter(Boolean) as number[];
    const comboKey = prendaIds.sort().join('-');
    if (usedCombos.has(comboKey)) continue;
    usedCombos.add(comboKey);

    const lookPrendas = [top, bottom, layer, acc].filter(Boolean) as Prenda[];
    if (lookPrendas.length < 2) continue;

    const ocasion = ocasiones[i % ocasiones.length] || 'Diario';
    const nombre = `${nombresBase[i % nombresBase.length]} ${i + 1}`;

    looks.push({
      id: comboKey,
      nombre,
      ocasion,
      prendas: lookPrendas,
      temporada,
    });
  }

  return looks;
}